import React, { useEffect, useState } from "react";
import "../../UserSetting/toggle-css.css";
import styles from "../settings.module.css";
import { Form } from "react-bootstrap";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import ReactTooltip from "react-tooltip";
import { useSelector, useDispatch } from "react-redux";
import { editCalenderSettings } from "../../../../../general_redux/general settings/actions";

function CalendarSettings() {
  const { setting } = useSelector(
    ({ generalSetting }) => generalSetting && generalSetting
  );
  const dispatch = useDispatch();
  const colorObj = useSelector(
    ({ generalSetting }) => generalSetting && generalSetting.setting.colors
  );
  const [allowBookingFor, setAllowBookingFor] = useState(
    setting && setting.allowBookingFor ? setting.allowBookingFor : "years"
  );
  const [numberOf, setNumberOf] = useState(
    setting && setting.numberOf ? setting.numberOf : 2
  );

  const [colorDictionary, setColorDictionary] = useState(colorObj);

  useEffect(() => {
    if (allowBookingFor === "years" && numberOf > 3) {
      setNumberOf(3);
    }
  }, [allowBookingFor]);

  const handleSave = (e) => {
    e.preventDefault();
    
    const data = {
      calendarSettings: {
        allowBookingFor: allowBookingFor,
        numberOf: Number(numberOf),
      },
      colorsSetting: colorDictionary,
    };
    dispatch(editCalenderSettings(data));
  };

  return (
    <div mt-1>
      <div className="pb-2 d-flex flex-direction-column">
        <h2 className={styles.settings__header}>Calendar Settings</h2>
      </div>
      <Form onSubmit={handleSave} className={styles.settings_wrapper} autoComplete="off">
        <div
          className={`input-group mb-3 pl-1 pl-sm-3 d-sm-flex d-block ${styles.input_group} ${styles.labelAdjustment}`}
        >
          <Form.Label className={`${styles.input_group_text}`}>
            Allow booking for:
            <InfoOutlinedIcon
              fontSize="small"
              style={{ color: "#737070" }}
              data-tip
              data-for="calendarIcon"
              className={styles.toolTipIconBooking}
            />
            <ReactTooltip
              place="bottom"
              type="dark"
              id="calendarIcon"
              effect="solid"
              className={styles.toolTip}
            >
              <span>
                You can block dates from being booked too far into the future.
                Select the time window you wish the calendar to be open for
                bookings. If you are connecting Beehaz to other calendars, make
                sure you set your calendar window in the OTAs accordingly.
                Beehaz cannot control the calendar window in other channels
              </span>
            </ReactTooltip>
          </Form.Label>
          <div className={`d-flex mt-3 mt-sm-0`}>
            <div>
              <input
                type="number"
                className={`form-control ${styles.numberOfField}`}
                id="numberOf"
                min={1}
                value={numberOf}
                name={"numberOf"}
                max={allowBookingFor === "years" ? 3 : 36}
                onChange={(e) => setNumberOf(e.target.value)}
              />
            </div>
            <div className={"mx-3 align-self-end"}>
              <input
                type="radio"
                value={"years"}
                onChange={(e) => setAllowBookingFor("years")}
                name={"allowBookingFor"}
                defaultChecked={allowBookingFor === "years"}
              />
              <label htmlFor="years"> &nbsp;&nbsp;Year(s)</label>
            </div>
            <div className={"mx-3 align-self-end"}>
              <input
                type="radio"
                value={"months"}
                onChange={(e) => setAllowBookingFor("months")}
                name={"allowBookingFor"}
                defaultChecked={allowBookingFor === "months"}
              />
              <label htmlFor="months"> &nbsp;&nbsp;Month(s)</label>
            </div>
            {/*<span className={`mt-1`}>Years</span>*/}
          </div>
        </div>
        <hr />
        <Form.Label
          className={`input-group mb-3 pl-1 pl-sm-3 d-sm-flex d-block ${styles.input_group} ${styles.labelAdjustment}`}
        >
          <div className={`${styles.input_group_text}`}>
            Colour dictionary:
            <InfoOutlinedIcon
              fontSize="small"
              style={{ color: "#737070" }}
              data-tip
              data-for="colorIcon"
              className={styles.toolTipIconBooking}
            />
            <ReactTooltip
              place="bottom"
              type="dark"
              id="colorIcon"
              effect="solid"
              className={styles.toolTip}
            >
              <span>
                You can choose the colours you wish to use when colour-coding
                reservations. You may assign meaning to the colours for future
                reference.
              </span>
            </ReactTooltip>
          </div>
          <br />
        </Form.Label>

        <Form.Row className={`pl-3 pl-sm-4 pb-2 flex-column flex-sm-row`}>
          {colorDictionary &&
            [...Array(8).keys()].map((item, index) => (
              <div key={index} className={`row col-sm-6`}>
                <Form.Label
                  className={`col-form-label pl-0 pr-1 ${styles.defaultFont}`}
                >
                  <input
                    type={"color"}
                    name={"color"}
                    value={colorDictionary[`color${index + 1}`]}
                    onChange={(e) => {
                      let tmpColorDict = { ...colorDictionary };
                      tmpColorDict[`color${index + 1}`] = e.target.value;
                      setColorDictionary(tmpColorDict);
                    }}
                    className={`d-flex ${styles.form_entry_color}`}
                  />
                </Form.Label>
                <div className={`m-0 p-0 col-9 pt-1 ${styles.defaultFont}`}>
                  <Form.Control
                    type="text"
                    value={colorDictionary[`description${index + 1}`]}
                    onChange={(e) => {
                      let tmpColorDict = { ...colorDictionary };
                      tmpColorDict[`description${index + 1}`] = e.target.value;
                      setColorDictionary(tmpColorDict);
                    }}
                    style={{ fontSize: "inherit" }}
                  />
                </div>
              </div>
            ))}
          {/* here 2 */}
        </Form.Row>
        <div className="d-flex justify-content-start">
          <button className={styles.settings_save} type="submit">
            Save Changes
          </button>
        </div>
      </Form>
    </div>
  );
}

export default CalendarSettings;
